import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
//import ReactSlider from 'react-slider'
import Slider from 'rc-slider'

import ZoomIcon from './ZoomIcon'
import styles from './ZoomSlider.scss'

class ZoomSlider extends React.Component {

	constructor() {
		super()
		this.state = {
			min: 0.1,
			max: 2,
			step: 0.1,
		}

		this.zoom = this.zoom.bind(this)
		this.zoomIn = this.zoomIn.bind(this)
		this.zoomOut = this.zoomOut.bind(this)
	}

	zoom(scale) {
		this.props.onChange(scale)
	}

	zoomIn() {
		const value = Math.min(this.state.max, this.props.scale+this.state.step)
		this.props.onChange(value)
	}

	zoomOut() {
		const value = Math.max(this.state.min, this.props.scale-this.state.step)
		this.props.onChange(value)
	}

	render() {
		return (
			<div styleName="ZoomSlider">
				<ZoomIcon in onClick={this.zoomIn} />
				<Slider
					className={styles['ZoomSlider-slider']}
					railStyle={{
						width: '2px',
						backgroundColor: 'white',
						cursor: 'pointer',
						height: '100%',
					}}
					handleStyle={{
						width: '8px',
						height: '8px',
						backgroundColor: 'white',
						borderRadius: '100%',
						position: 'absolute',
						left: '-3px',
					}}
					trackStyle={{
						display: 'none',
					}}
					vertical={true}
					value={this.props.scale}
					min={this.state.min}
					max={this.state.max}
					step={this.state.step}
					onChange={this.zoom}
				/>
				<ZoomIcon out onClick={this.zoomOut} />
			</div>
		)
	}

}

ZoomSlider.propTypes = {
	scale: PropTypes.number,
	onChange: PropTypes.func.isRequired,
}

ZoomSlider.defaultProps = {
	scale: 1,
	onChange: () => {},
}

export default CSSModules(ZoomSlider, styles, { allowMultiple: true })
